import React from 'react';
import Logo from '../assets/Logo.png';
import { BsTwitter, BsYoutube } from 'react-icons/bs';
import { FaLinkedinIn, FaFacebookF, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className='footer-wrapper'>
      <div className='footer-section-one'>
        <div className='footer-logo-container'>
          <img src={Logo} alt="CraveOn Logo" />
        </div>

        <p className="footer-description">
          Fresh food, fast delivery, and delicious experiences delivered to your doorstep.
        </p>

        <div className='footer-icons'>
          <FaInstagram />
          <FaFacebookF />
          <BsTwitter />
          <FaLinkedinIn />
          <BsYoutube />
        </div>
      </div>


      <div className='footer-section-two'>

        <div className='footer-section-columns'>
          <p className='primary-subheading'>Quick Link</p>
          <a href="#aboutus">About Us</a>
          <a href="#howitworks">How It Works</a>
          <span>Careers</span>
          <span>Our Work</span>
          <a href="#testimonials">Testimonials</a>
        </div>


        <div className='footer-section-columns'>
          <p className='primary-subheading'>Support</p>
          <span>Help Center</span>
          <span>FAQs</span>
          <span>Terms & Conditions</span>
          <span>Privacy Policy</span>
        </div>


        <div className='footer-section-columns'>
          <p className='primary-subheading'>Contact Us</p>
          <span>📞 244-5333-7783</span>
          <span>✉ hello@craveon.com</span>
          <span>✉ press@craveon.com</span>
          <span>✉ contact@craveon.com</span>
        </div>

      </div>


      {/* <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} CraveOn. All Rights Reserved.
        </p>
      </div> */}

    </footer>
  );
}

export default Footer;
